import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class Toggle extends Component {
    static propTypes = {
        theme: PropTypes.string,
        type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
        value: PropTypes.bool.isRequired,
        onChange: PropTypes.func,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        disabled: PropTypes.bool,
        small: PropTypes.bool,
    };

    static defaultProps = {
        size: 'md',
        theme: 'primary',
    };

    handleChange(event) {
        if (this.props.onChange) this.props.onChange(event.target.checked);
    }

    renderIcon() {
        if (this.props.type === 'checkbox') {
            return <i className='material-icons'>{this.props.value ? 'check_box' : 'check_box_outline_blank'}</i>;
        }
        if (this.props.type === 'radio') {
            return (
                <i className='material-icons'>{this.props.value ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
            );
        }
    }

    render() {
        const rootClassNames = classNames(
            styles.root,
            styles[`theme-${this.props.theme}`],
            this.props.disabled && styles.disabled,
            this.props.value && styles.selected
        );

        const labelClassNames = classNames(styles.label, this.props.small && styles.small);

        return (
            <div className={rootClassNames}>
                <input
                    type='checkbox'
                    checked={Boolean(this.props.value)}
                    disabled={this.props.disabled}
                    onChange={this.handleChange}
                />
                {this.renderIcon()}
                {this.props.label && <div className={labelClassNames}>{_(this.props.label)}</div>}
            </div>
        );
    }
}
